import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './App.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { AuthModalProvider } from './context/AuthModalContext';
import { SavedProvider } from './context/SavedContext';
import { initMonitoring } from './utils/monitoring';

initMonitoring();

// An invite link (?ref=username) can land on any page; remember it so the
// signup that follows, now or later, credits the friend who sent it.
try {
  const ref = new URLSearchParams(window.location.search).get('ref');
  if (ref) localStorage.setItem('uf-ref', ref.slice(0, 40));
} catch { /* storage blocked */ }

// createRoot, not hydrateRoot, even though prerendered routes ship with markup
// already in #root: the snapshots are rendered logged-out, so hydrating them
// for a signed-in visitor would mismatch on every auth-dependent branch.
// React discards the existing children and renders fresh, which is what we want
// — the snapshot exists for crawlers, not to save the browser a render.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <AuthProvider>
        <AuthModalProvider>
          <SavedProvider>
            <App />
          </SavedProvider>
        </AuthModalProvider>
      </AuthProvider>
    </HelmetProvider>
  </React.StrictMode>
);
